export const HERO_POSTER = '/images/hero-poster.jpg';
export const PERFUME_BRAND_IMAGE = '/media/perfume-brand.png';
export const PERFUME_MACRO_VIDEO = '/media/perfume-macro.mp4';
export const CRISTIAN_PHOTO = '/media/cristian.png';
